import { render, staticRenderFns } from "./all_Record.vue?vue&type=template&id=c522d0e6&"
import script from "./all_Record.vue?vue&type=script&lang=js&"
export * from "./all_Record.vue?vue&type=script&lang=js&"
import style0 from "./all_Record.vue?vue&type=style&index=0&id=c522d0e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports